import { render, staticRenderFns } from "./nav-menu.vue?vue&type=template&id=a35b645a&"
import script from "./nav-menu.vue?vue&type=script&lang=js&"
export * from "./nav-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports